<!-- <ng4-loading-spinner [timeout]="2147483647"> </ng4-loading-spinner>
<app-nav-menu></app-nav-menu>
<NotificationCenter></NotificationCenter>
<div class="mainBody">
    <div class="container-fluid">
        <router-outlet></router-outlet>
    </div>
</div> -->
<router-outlet></router-outlet>

<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>TITLE.TITLE_ALERT</h6>
    </div>
    <div class="modal-body">
        <span>{{'LBL.EXPIRY_PASSWORD_PROMPT' | translate : dayObj}}</span>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="c('close')" translate>BTN.BTN_OK</button>
    </div>
</ng-template>
